import type { TRuleWithTheme } from 'styles/theme';

export const icon: TRuleWithTheme = () => ({
    fontSize: '1.26rem',
});
export const text: TRuleWithTheme = ({ theme }) => ({
    fontSize: '1rem',
    color: theme.colors.primary,
    // marginTop: '1px',
    marginLeft: '0.70rem',
    fontWeight: 600,
});
// Applied to the antd Dropdown.Button wrapper, so sizing/spacing has to be
// pushed down onto its nested .ant-btn elements rather than set directly.
// The icon-only trigger segment (.ant-btn-icon-only) is excluded so it keeps
// antd's compact square sizing instead of inheriting the label button's width.
export const button: TRuleWithTheme = () => ({
    marginRight: '0.63rem',
    '& .ant-btn:not(.ant-btn-icon-only)': {
        height: '32px',
        fontSize: '0.88rem',
        padding: '5px 16px',
        minWidth: '5.5rem',
    },
    '& .ant-btn-icon-only': {
        width: '32px',
        height: '32px',
    },
});
export const buttonLoading: TRuleWithTheme = () => ({
    marginRight: '0.63rem',
    '& .ant-btn:not(.ant-btn-icon-only)': {
        height: '32px',
        fontSize: '0.88rem',
        padding: '5px 16px',
        minWidth: '5.5rem',
        backgroundColor: '#F39C70 !important',
        background: '#F39C70 !important',
        borderColor: '#F39C70 !important',
    },
    '& .ant-btn-icon-only': {
        width: '32px',
        height: '32px',
    },
    '& .ant-btn:hover': {
        backgroundColor: '#F39C70 !important',
        background: '#F39C70 !important',
        borderColor: '#F39C70 !important',
    },
});
// The dropdown overlay is rendered in a portal outside this component's DOM
// tree, so it's applied directly to the antd Menu.Item rather than nested
// under `button`/`buttonContainer`.
export const editMenuItem: TRuleWithTheme = ({ theme }) => ({
    backgroundColor: `${theme.colors.primary} !important`,
    color: `${theme.colors.white} !important`,
    ':hover': {
        backgroundColor: `${theme.colors.btnPrimaryHover} !important`,
        color: `${theme.colors.white} !important`,
    },
});
export const buttonReject: TRuleWithTheme = ({ theme }) => ({
    color: '#939393',
    height: '32px',
    fontSize: '0.88rem',
    padding: '5px 16px',
    marginRight: '0.63rem',
    minWidth: '5.5rem',
});
export const buttonContainer: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
});
